export default __webpack_public_path__ + "static/media/warehouse.141c6c74.png";